// Centralized API client helper to standardize base URL resolution and error handling

const DEV_BASE = process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:3000/api';
const PROD_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

function baseUrl() {
  return process.env.NODE_ENV === 'development' ? DEV_BASE : PROD_BASE;
}

export function getApiBaseUrl() {
  return baseUrl();
}

export async function apiGet(path, { params } = {}) {
  const url = new URL(path.startsWith('http') ? path : `${baseUrl()}${path.startsWith('/') ? path : '/' + path}`);
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') url.searchParams.set(k, v);
    });
  }
  const res = await fetch(url.toString());
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Request failed (${res.status}): ${text || url.toString()}`);
  }
  return res.json();
}

export async function apiPost(path, body, { headers = {} } = {}) {
  const res = await fetch(`${baseUrl()}${path.startsWith('/') ? path : '/' + path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Request failed (${res.status}): ${text}`);
  }
  return res.json();
}
